// Material UI
import { makeStyles } from '@material-ui/core';
import { neutral, orange } from '../../../../shared/styles/colors';

export default makeStyles(theme => ({
  root: {
    backgroundColor: orange[10],
    borderLeft: `3px solid ${orange[60]}`,
    padding: '0.5rem 1rem',
    margin: '0.5rem 0',
  },
  LabelText: {
    color: neutral[80],
    fontFamily: 'PP Object Sans',
    fontSize: '0.75rem',
    fontWeight: 500,
  },
  productSuggestText: {
    color: neutral[80],
    fontFamily: 'PP Object Sans',
    fontSize: '0.75rem',
    fontWeight: 500,
  },
  LabelComment: {
    color: neutral[100],
    fontFamily: 'PP Object Sans',
    fontSize: '0.875rem',
    fontWeight: 500,
  },
}));
